import { gql } from "@apollo/client";

export const REALITY_SEARCH_QUERY = gql`
  query RealitySearch(
    $message: String!
    $history: [RealityHistoryInput!]
  ) {
    realitySearch(
      message: $message
      history: $history
    ) {
      answer
      pagesViewedCount
      durationMs
      sources {
        id
        name
        pages {
          pageIndex
        }
      }
    }
  }
`;